import type { AnyRoute } from "@tanstack/react-router";

import { createProfileSummaryRoutes } from "./createProfileSummaryRoutes";
import type { WorkforceRouteDeps } from "./workforceRouteContext";

export type {
  WorkforceRouteDeps,
  WorkforceRouteFactory,
} from "./workforceRouteContext";

export function createWorkforceRoutes(deps: WorkforceRouteDeps): AnyRoute[] {
  return [...createProfileSummaryRoutes(deps)];
}
